export default "__VITE_ASSET__EFH64kYT__"